import moment from 'moment';

import { EventRecurrenceDto, HowLongDto, HowLongMode, RecurrenceType } from 'api/dtos/event';

const getStartDate = (dateFrom: string) => {
    const parsedDate = moment(dateFrom);
    return parsedDate.isValid() ? parsedDate : moment();
};

export const getRecurrenceForType = (
    type: RecurrenceType,
    dateFrom: string,
): EventRecurrenceDto => {
    const startDate = getStartDate(dateFrom);

    switch (type) {
    case RecurrenceType.Daily:
        return {
            type,
            daily: { interval: 1 },
        };
    case RecurrenceType.Weekly:
        return {
            type,
            weekly: {
                interval: 1,
                days: [startDate.isoWeekday() - 1],
            },
        };
    case RecurrenceType.Monthly:
        return {
            type,
            monthly: {
                interval: 1,
                dayOfMonth: startDate.date(),
            },
        };
    case RecurrenceType.Yearly:
        return {
            type,
            yearly: {
                month: startDate.month() + 1,
                dayOfMonth: startDate.date(),
            },
        };
    default:
        return {
            type: RecurrenceType.None,
        };
    }
};

export const syncRecurrenceWithStartDate = (
    recurrence: EventRecurrenceDto,
    dateFrom: string,
) => {
    if (recurrence.type === RecurrenceType.Daily) {
        return { ...recurrence, daily: recurrence.daily ?? { interval: 1 } };
    }

    return getRecurrenceForType(recurrence.type, dateFrom);
};

export const getOneYearRecurrenceEndDate = () => (
    moment().add(1, 'year').format('YYYY-MM-DD')
);

export const normalizeHowLongForSubmit = (
    recurrence: EventRecurrenceDto,
    howLong: HowLongDto | null | undefined,
): HowLongDto | undefined => {
    if (recurrence.type === RecurrenceType.None || recurrence.type === RecurrenceType.Yearly) {
        return undefined;
    }

    if (howLong?.mode === HowLongMode.ForXTimes) {
        return {
            mode: HowLongMode.ForXTimes,
            times: howLong.times && howLong.times > 0 ? howLong.times : 1,
        };
    }

    if (howLong?.mode === HowLongMode.UntilDate && howLong.untilDate) {
        return howLong;
    }

    return {
        mode: HowLongMode.UntilDate,
        untilDate: getOneYearRecurrenceEndDate(),
    };
};
